






























import { Component, Vue, Watch } from 'vue-property-decorator'
import { removeGarbageFromString, removeNonAscii } from '@/helpers/features/smartfixes/remove-garbage'

@Component({
  components: {
    HelpCircle: require('@/components/HelpCircle').default
  }
})
export default class Parsed extends Vue {
  separator: string = this.$store.state.trackmatching.separator
  swapArtistTitle: boolean = this.$store.state.trackmatching.swapArtistTitle
  fuzzySearch: boolean = true

  columns: any[] = [
    {
      field: 'title',
      label: 'Title',
      width: '50%',
      sortable: true
    },
    {
      field: 'artist',
      label: 'Artist',
      width: '50%',
      sortable: true
    }
  ]

  get disabled(): boolean {
    return false
  }

  get lines(): string[] {
    return this.$store.state.trackmatching.lines
  }

  get parsedLines(): string[][] { // A parsed line should be artist at index 0 and title at index 1
    if (!this.separator) return []

    return this.lines.map(x => {
      let separator: string = this.separator

      if (separator === '-' && this.lines.every(x => x.includes('–'))) separator = '–' // Double dash (from Word?): very similar but not a real dash

      const s = x.split(separator)

      const firstField: string = removeGarbageFromString(s[0])

      if (s.length === 1) { // No separator found
        return ['', firstField]
      } else {
        const secondField: string = removeGarbageFromString(s[1])

        if (!firstField) { // First field empty, this line was "- Artist"
          return [secondField, '']
        } else {
          return [this.swapArtistTitle ? secondField : firstField, this.swapArtistTitle ? firstField : secondField]
        }
      }
    })
  }

  get tableData(): { artist: string, title: string }[] {
    return this.parsedLines
      .map(x => {
        return {
          artist: removeNonAscii(x[0]),
          title: removeNonAscii(x[1])
        }
      })
  }

  back() {
    this.$router.go(-1)
  }

  async pipeToStoreLinks() {
    this.$store.commit('storelinks/setCombos', this.tableData.map(x => [x.title, x.artist]))

    await this.$router.replace({
      name: 'store links input',
      query: {
        activeTab: '1'
      }
    })
  }

  async confirm() {
    this.$store.commit('trackmatching/setParsedLines', this.parsedLines)
    this.$store.commit('trackmatching/setFuzzySearch', this.fuzzySearch)

    await this.$router.push({
      name: 'trackmatching result'
    })
  }

  async created() {
    if (this.lines.length === 0) {
      console.warn('no trackmatching lines found')

      await this.$router.replace({
        name: 'trackmatching choice'
      })
    }
  }

  @Watch('swapArtistTitle')
  watchSwapArtistTitle() {
    this.$store.commit('trackmatching/setSwapArtistTitle', this.swapArtistTitle)
  }
}
